export const user = () => [
  { path: '/main/users',          text: 'user' },
  { path: '/main/company',        text: 'company' },
  { path: '/main/groups',         text: 'groups' },
  { path: '/main/system-modules', text: 'system_modules' },
  { path: '/main/permission',     text: 'permissions' },
]

export const testRegister = () => [
  { path: '/main/garageaccrediteds', text: 'garages_accrediteds_register' },
  { path: '/main/maintancereasons', text: 'maintance_reasons_register' },
  { path: '/main/causeofmaintance', text: 'cause_of_maintance_register' },
  { path: '/main/bankaccounts', text: 'bank_accounts_register' },
  { path: '/main/vehiclebrands', text: 'vehicle_brands_register' },
  { path: '/main/banks', text: 'banks_register' },
  { path: '/main/acessories', text: 'acessories_register' },
  { path: '/main/shippingmethodtransportation', text: 'shipping_method_transportation_register' },
  { path: '/main/shippingdestinytransportation', text: 'shipping_destiny_transportation_register' },
]

export const stockRegister = () => [
  { path: '/main/actives',                       text: 'actives_register' },
  { path: '/main/activestypes',                  text: 'actives_types_register' },
  { path: '/main/manufacturers',                 text: 'manufacturers_register' },
  { path: '/main/models',                        text: 'models_register' },
  { path: '/main/active-status',                 text: 'active_status_register' },
  { path: '/main/status',                        text: 'status_register' },
  { path: '/main/movementtype',                  text: 'movement_type_register' },
  { path: '/main/components',                    text: 'component_register' },
  { path: '/main/active-status-default-removed', text: 'default_status_actives_removed' },
  { path: '/main/equipments-data',               text: 'edit_equipments' },
  { path: '/main/stock-alerts',                  text: 'alerts' },
]

export const parameters = () => [
  { path: '/main/commandtypes',       text: 'command_types' },
  { path: '/main/servicetypes',       text: 'service_types' },
  { path: '/main/positionsandoffset', text: 'positions_offset' },
  { path: '/main/arenavehicles2001',  text: 'arena_vehicles_2001' },
]

export const reports = () => [
  { path: '/main/reportactivemovement', text: 'actives_movement', type: 'equipment' },
  { path: '/main/reportlastpositions', text: 'last_positions', type: 'equipment' },
  { path: '/main/reporttrackers', text: 'inventory_trackers', type: 'equipment' },
  { path: '/main/reportstockinventory', text: 'inventory_stock', type: 'equipment' },
  { path: '/main/reportdevicelogs', text: 'device_logs', type: 'equipment' },
  { path: '/main/reportdrivebehavior', text: 'drive_behavior', type: 'equipment' },
  { path: '/main/reporttemperaturesensordelay', text: 'temperature_sensor_delay', type: 'equipment' },
  { path: '/main/reportRFIDReaderDelay', text: 'rfid_reader_delay', type: 'equipment' },
  { path: '/main/reportcomissions', text: 'comissions_report', type: 'financial' },
  { path: '/main/reportroteirizations', text: 'roteirizations_report', type: 'financial' },
  { path: '/main/reportcostmaterialtransportation', text: 'cost_material_transportation', type: 'financial' },
  { path: '/main/reportservicebyclient', text: 'service_by_client_report', type: 'service' },
]

export const consults = () => [
  { path: '/main/vehicles',      text: 'vehicles' },
  { path: '/main/iccids',        text: 'ICCID' },
  { path: '/main/oslogs',        text: 'os_logs' },
  { path: '/main/checklist',     text: 'checklist' },
]

export const appFrotixRegisters = () => [
  { path: '/main/remoteid', text: 'remote_id' },
  { path: '/main/api-geocode-engine', text: 'geocode_engine' },
  { path: '/main/user-web-service', text: 'user_web_service' },
]

export const financial = () => [
  { path: '/main/financial/vehicles', text: 'vehicles' },
  { path: '/main/financial/contracts', text: 'contracts' },
]

export const arena = () => [
  { path: '/main/arena/equipments', text: 'equipments' },
  { path: '/main/arena/equipment-version', text: 'equipment_version' },
  { path: '/main/arena/vehicle-type', text: 'vehicle_type' },
  { path: '/main/arena/point-type', text: 'point_type' },
  { path: '/main/arena/user', text: 'user' },
  { path: '/main/arenaevents', text: 'events' },
  { path: '/main/arena/linkvehicleandareagenerateevents', text: 'link_vehicle_and_area_generate_events' },
  { path: '/main/arena/clean-positions', text: 'clean_positions' },
  { path: '/main/arena/clean-triggered-events', text: 'clean_triggered_events' },
  { path: '/main/offsetbyplate', text: 'offset_plate' },
  { path: '/main/arena/vei-off-temp', text: 'vei_off_temp' },
]

export const frota = () => [
  { path: '/main/frota/drivers', text: 'drivers' },
  { path: '/main/frota/helpers', text: 'helpers' },
  { path: '/main/frota/infractions-types', text: 'Tipos de Infrações' },
]

export const atendimentos = () => [
  { path: '/main/atendimentos/signature', text: 'Signature' },
  { path: '/main/atendimentos/tires', text: 'Pneus' },
]

export const integrador = () => [
  { path: '/main/integrador/roteirization', text: 'active_inactive_roteirization' },
  { path: '/main/integrador/integrator', text: 'integrator_settings' },
  { path: '/main/integrador/custom-delivery-details', text: 'custom_delivery_details' },
  { path: '/main/integrador/integrator-install-instructions', text: 'integrator_install_instructions' },
]

export const frotixManagement = () => [
  { path: '/main/frotix-management/vehicle-evolution', text: 'vehicle_evolution', type: 'frotix_management' },
]
